"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcComponentBlock = void 0;
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcComponentBlock_module_scss_1 = __importDefault(require("./AcComponentBlock.module.scss"));
var AcComponentBlock = function (props) {
    var _a, _b, _c, _d;
    var customStyle = props.customStyle, center = props.center, children = props.children, header = props.header, footer = props.footer, className = props.className, contentClassName = props.contentClassName;
    return (react_1.default.createElement(react_bootstrap_1.Card, { className: clsx_1.default('shadow-sm border-0', (_a = {}, _a[AcComponentBlock_module_scss_1.default.componentBlock] = true, _a), className), style: customStyle },
        header && (react_1.default.createElement(react_bootstrap_1.Card.Header, { className: clsx_1.default('border-apzwhitegrayblue rounded-top', (_b = {},
                _b[AcComponentBlock_module_scss_1.default.componentBlockContent] = true,
                _b), contentClassName) }, header)),
        react_1.default.createElement(react_bootstrap_1.Card.Body, { className: clsx_1.default({
                'd-flex align-items-center justify-content-center': center,
            }, (_c = {}, _c[AcComponentBlock_module_scss_1.default.componentBlockContent] = true, _c), contentClassName) }, children),
        footer && (react_1.default.createElement(react_bootstrap_1.Card.Footer, { className: clsx_1.default('border-apzwhitegrayblue rounded-bottom', (_d = {},
                _d[AcComponentBlock_module_scss_1.default.componentBlockContent] = true,
                _d), contentClassName) }, footer))));
};
exports.AcComponentBlock = AcComponentBlock;
//# sourceMappingURL=AcComponentBlock.js.map